import { Link } from '@material-ui/core';
import {
  formatLoadPaymentMethod,
  formatLoadPaymentTerm,
  formatPaymentMethod,
  formatPaymentTerm,
  isValidLoadPaymentMethod,
  isValidLoadPaymentTerm,
  isValidPaymentMethod,
  isValidPaymentTerm,
} from '@superdispatch/sdk';
import { parseURITemplate } from '@superdispatch/uri';
import { chooseUTMSource } from 'shared/helpers/Analytics';
import { SuperPayIcon } from 'shared/icons/SuperPayLabel';

const isSLBM = import.meta.env.VITE_APP_NAME === 'slbm';

interface SuperPayLabelProps {
  source?:
    | 'Load Details'
    | 'Load List'
    | 'Load Offer'
    | 'Suggested Load'
    | 'Load Offer Details'
    | 'Public Load Offer Details'
    | 'Public Load Offer Declined';
  target?: '_blank' | '_self';
}

export function SuperPayLabel({
  source,
  target = '_self',
}: SuperPayLabelProps) {
  return (
    <Link
      rel="noreferrer"
      color="primary"
      href={parseURITemplate(
        `${
          isSLBM ? '/tms-webview/superpay' : '/tms/profile/superpay'
        }{?utm_source,utm_medium,utm_content}`,
        {
          utm_source: chooseUTMSource(),
          utm_medium: source,
          utm_content: 'Superpay label',
        },
      )}
      onClick={(event) => {
        event.stopPropagation();
      }}
      target={target}
    >
      <SuperPayIcon />
    </Link>
  );
}

// Carrier TMS mixed payment methods and terms. So we will try to format for all possible cases
export function formatLoadPayment(payment: unknown) {
  if (isValidPaymentMethod(payment)) {
    return formatPaymentMethod(payment);
  }

  if (isValidPaymentTerm(payment)) {
    return formatPaymentTerm(payment);
  }

  if (isValidLoadPaymentTerm(payment)) {
    return formatLoadPaymentTerm(payment);
  }

  if (isValidLoadPaymentMethod(payment)) {
    return formatLoadPaymentMethod(payment);
  }

  if (payment) {
    return String(payment);
  }

  return 'Unknown';
}
